module.exports = __webpack_public_path__ + "img/mail-active.6b5f980c.svg";